
import { defineComponent, ref, getCurrentInstance, computed } from 'vue';
import debounce from 'lodash/debounce'
import { roundingNum } from '@/common/utils';
import { sendLog } from '~/common/radar';
export default defineComponent({
  props: {
    isLoginStatus: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
    cardType: {
      type: String,
      default: () => '',
    }
  },
  setup(props) {
    const followed = ref(props.data.isFollowings);
    const { proxy } = getCurrentInstance() as { proxy: any }
    const text = computed(() => {
      return followed.value ? proxy.$root.$t('k_336137') : proxy.$root.$t('k_335868')
    })
    const hasFollowers = computed(() => {
      const { followers } = props.data ?? {};
      if (followers && followers !== 'null' && followers !== '0') return true;
      return false;
    });

    const hasVideos = computed(() => {
      const { videos } = props.data ?? {};
      if (videos && videos !== 'null' && videos !== '0') return true;
      return false;
    });

    const handleFollow = () => {
      if(followed.value) return
      sendLog({
        type: 'click',
        name: 'USER_ELEMENT',
        value: {
          author_id: props.data?.userId,
          follow: props.data?.followers,
          video: props.data?.videos,
          card_type: props?.cardType,
          button_type: 'follow'
        }
      })
      // 判断是否登陆，未登陆调起登陆面板
      if (!props.isLoginStatus) {
        proxy.$bus.emit('changeLoginPopupShow', true)
      } else {
        // 已登陆，提示关注成功，走fake逻辑
        followed.value = true;
        proxy.$bus.emit('follow', { kwaiId: props.data.kwaiId, type: 1 })
      }
    };

    const handleJumpProfile = (button_type: string) => {
      sendLog({
        type: 'click',
        name: 'USER_ELEMENT',
        value: {
          author_id: props.data?.userId,
          follow: props.data?.followers,
          video: props.data?.videos,
          card_type: props?.cardType,
          button_type
        }
      })
      proxy.$bus.emit('jumpProfile', props.data.kwaiId)
    }

    const debounceClickFollowAction = debounce(handleFollow, 500, { leading: true, trailing: false })

    return {
      followed,
      text,
      handleFollow,
      handleJumpProfile,
      roundingNum,
      debounceClickFollowAction,
      hasVideos,
      hasFollowers,
    };
  },
});

